import { useTranslation } from "react-i18next";
import { useState } from "react";
import SupportTicketModal from "../SupportTicketModal";

const Footer = () => {
  const { t } = useTranslation();
  const [isSupportTicketModalOpen, setIsSupportTicketModalOpen] = useState(false);

  return (
    <footer className="text-white bg-dark-gray background-position-right-top background-no-repeat md-background-image-none pt-4 pb-2">
      <div className="container">
        <div className="row justify-content-center text-center text-sm-start">
          <div className="col-lg-6 col-sm-6 xs-mb-35px">
            <div>
              <img
                src="/images/logos/apcg-white-logo.png"
                alt="APCG logo"
                className="default-logo"
                style={{ maxHeight: "85px" }}
              />
              <img
                src="/images/APFG_logo-2.png"
                alt="APFG logo"
                className="default-logo"
                style={{ maxHeight: "170px", marginBottom: "20px" }}
              />
            </div>
            <div>
              <img
                src="/images/partners/moe-svg.svg"
                alt="Ministry of Education logo"
                className="default-logo"
                style={{ maxHeight: "85px", marginBottom: "20px" }}
              />
              <img
                src="/images/logos/ubt-logo-white.png"
                alt="University of Business and Technology logo"
                className="default-logo"
                style={{ maxHeight: "85px", marginBottom: "20px" }}
              />
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 md-mb-35px">
            <span className="alt-font d-block text-base-color mb-10px fs-20">
              <i className="feather icon-feather-phone-call align-text-bottom icon-extra-medium text-base-color me-10px" />
              {t("footer.contactUs")}
            </span>
            <span>{t("footer.organizingCommittee")}</span>
            <br />
            <a
              href="mailto:info@apcg2026-saudiarabia.org"
              className="d-inline-block text-white mb-5px"
            >
              info@apcg2026-saudiarabia.org
            </a>
            <br />
            <a
              href="#"
               className="text-white text-decoration-line-bottom text-uppercase fs-15 alt-font fw-500"
              onClick={(e) => {
                e.preventDefault();
                setIsSupportTicketModalOpen(true);
              }}
             
            >
              {t("footer.supportTicket")}
            </a>
          </div>

          <div className="col-lg-3 col-sm-6 md-mb-35px">
            <span className="alt-font d-block text-base-color mb-10px fs-20">
              <i className="feather icon-feather-map-pin align-text-bottom icon-extra-medium text-base-color me-10px" />
              {t("footer.venueInfos")}
            </span>
            <p className="w-80 lg-w-100 md-w-70 sm-w-90 xs-w-100 mb-5px">
              {t("footer.venueAddress")}
            </p>
            <a
              href="https://maps.google.com/maps?ll=21.568563,39.113063"
              className="text-white text-decoration-line-bottom text-uppercase fs-15 alt-font fw-500"
              target="_blank"
              rel="noreferrer"
            >
              {t("footer.getDirections")}
            </a>
          </div>
        </div>
        <div className="row justify-content-center text-center my-4">
          <div className="col-12">
            <div className="social-icons">
              <a
                href="https://twitter.com/apcg2026"
                target="_blank"
                rel="noreferrer"
                className="text-white me-3"
              >
                <i className="fa-brands fa-twitter fa-lg" />
              </a>
              <a
                href="https://www.facebook.com/61575501654177"
                target="_blank"
                rel="noreferrer"
                className="text-white me-3"
              >
                <i className="fa-brands fa-facebook fa-lg" />
              </a>
              <a
                href="https://www.instagram.com/apcg2026"
                target="_blank"
                rel="noreferrer"
                className="text-white me-3"
              >
                <i className="fa-brands fa-instagram fa-lg" />
              </a>
              <a
                href="https://www.linkedin.com/company/apcg2026/posts/?feedView=all"
                target="_blank"
                rel="noreferrer"
                className="text-white me-3"
              >
                <i className="fa-brands fa-linkedin fa-lg" />
              </a>
              <a
                href="https://www.youtube.com/@APCG2026"
                target="_blank"
                rel="noreferrer"
                className="text-white"
              >
                <i className="fa-brands fa-youtube fa-lg" />
              </a>
            </div>
          </div>
        </div>
        <div className="row align-items-center pt-6 md-pt-0px">
          <div className="col text-base-color text-center last-paragraph-no-margin">
            <p>
              <span style={{ direction: "ltr", display: "inline-block" }}>
                {t("footer.copyright")} {new Date().getFullYear()}
              </span>{" "}
              <a
                className="text-base-color"
                href="https://www.ubt.edu.sa/"
                target="_blank"
                rel="noreferrer"
              >
                UBT
              </a>
              . {t("footer.allRightsReserved")}
              <span className="mx-2">|</span>
              <a
                href="/sitemap.xml"
                className="text-base-color"
                target="_blank"
                rel="noreferrer"
              >
                {t("footer.xmlSitemap")}
              </a>
              <span className="mx-2">|</span>
              <a href="/sitemap" className="text-base-color">
                {t("footer.htmlSitemap")}
              </a>
              <span className="mx-2">|</span>
              <a href="/privacy-policy" className="text-base-color">
                {t("footer.privacyPolicy")}
              </a>
              <span className="mx-2">|</span>
              <a href="/terms-and-conditions" className="text-base-color">
                {t("footer.termsConditions")}
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Support Ticket Modal */}
      <SupportTicketModal
        isOpen={isSupportTicketModalOpen}
        onClose={() => setIsSupportTicketModalOpen(false)}
      />
    </footer>
  );
};

export default Footer;
